<p class="text-right mb-2 flex flex-col">
  <span class="text-grey-dark-3 font-bold align-text-top">
    {{
      timeslot?.minPriceOffer?.price
        | displayPrice
          : timeslot?.minPriceOffer?.currency
          : timeslot?.maxPriceOffer?.price
    }}
  </span>

  <span
    *ngIf="isBg && timeslot?.minPriceOffer?.price !== 0"
    class="text-grey-dark-3 font-bold align-text-top"
  >
    {{
      timeslot?.minPriceOffer?.price
        | priceConversion
        | displayPrice: '€' : (timeslot?.maxPriceOffer?.price | priceConversion)
    }}
  </span>
</p>
